export enum ContractorType {
  Residential = 'Residential',
  Commercial = 'Commercial'
}